import { Card } from '@cortex/web-design-system/components/ui/Card';
import type { CsDailySummary } from '../../types/cs-inquiry.js';

/**
 * @graph-connects none
 */
export function formatSeconds(seconds: number | null): string {
  if (seconds === null) return '-';
  if (seconds < 60) return `${String(Math.round(seconds))}秒`;
  if (seconds < 3600) return `${String(Math.round(seconds / 60))}分`;
  return `${(seconds / 3600).toFixed(1)}時間`;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 問い合わせ日次詳細テーブル。日付・件数・会員数・発生率・初回応答・解決時間を一覧表示する。
 * @graph-connects none
 */
export function CsDailyDetailTable({ rows }: { rows: CsDailySummary[] }) {
  return (
    <Card className="p-4">
      <h3 className="mb-3 text-sm font-semibold text-[var(--color-text-primary)]">日次詳細</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-[var(--color-border)]">
              <th className="px-3 py-2 text-left font-medium text-[var(--color-text-muted)]">
                日付
              </th>
              <th className="px-3 py-2 text-right font-medium text-[var(--color-text-muted)]">
                問い合わせ数
              </th>
              <th className="px-3 py-2 text-right font-medium text-[var(--color-text-muted)]">
                会員数
              </th>
              <th className="px-3 py-2 text-right font-medium text-[var(--color-text-muted)]">
                発生率
              </th>
              <th className="px-3 py-2 text-right font-medium text-[var(--color-text-muted)]">
                平均初回応答
              </th>
              <th className="px-3 py-2 text-right font-medium text-[var(--color-text-muted)]">
                平均解決時間
              </th>
            </tr>
          </thead>
          <tbody>
            {[...rows].reverse().map((row) => {
              const rate =
                row.memberCount !== null && row.memberCount > 0
                  ? (row.newChats / row.memberCount) * 100
                  : null;
              return (
                <tr
                  key={row.date}
                  className="border-b border-[var(--color-border)] last:border-b-0"
                >
                  <td className="px-3 py-2 text-[var(--color-text-primary)]">{row.date}</td>
                  <td className="px-3 py-2 text-right text-[var(--color-text-primary)]">
                    {row.newChats.toLocaleString('ja-JP')}
                  </td>
                  <td className="px-3 py-2 text-right text-[var(--color-text-primary)]">
                    {row.memberCount !== null ? row.memberCount.toLocaleString('ja-JP') : '-'}
                  </td>
                  <td className="px-3 py-2 text-right text-[var(--color-text-primary)]">
                    {rate !== null ? `${rate.toFixed(3)}%` : '-'}
                  </td>
                  <td className="px-3 py-2 text-right text-[var(--color-text-primary)]">
                    {formatSeconds(row.avgFirstResponseSeconds)}
                  </td>
                  <td className="px-3 py-2 text-right text-[var(--color-text-primary)]">
                    {formatSeconds(row.avgResolutionSeconds)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
